const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLForm = require('app/graphql/Form');

class DeliveryForm extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'SubmitRestaurantSupplierAssociationDeliveries',
            'restaurant': null,
            'supplier': null,

            'onClickBack': function(form){},
            'onChange': function(){},
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.onClickBack = this.onClickBack.bind(this);
        this.onClickBtnAddDeliveryDay = this.onClickBtnAddDeliveryDay.bind(this);

        this.restaurant = this.settings.restaurant;
        this.supplier = this.settings.supplier;
        this.changed = false;

        this.$form = $('<form/>')
        .addClass('restaurant-supplier-delivery-form');

        this.loadData();

        super.initialize();
    }

    hasChange(){
        return this.changed;
    }

    getRestaurant(){
        return this.restaurant;
    }

    getSupplier(){
        return this.supplier;
    }

    getForm(){
        return this.$form;
    }

    loadData(){
        var self = this;

        this.$form
        .html('')
        .append(window.App.generateLoader());

        let queries = [
            this.buildSupplierAssociationQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.fillForm(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildSupplierAssociationQuery(){
        var self = this;

        let parameters = {
            'restaurant': this.restaurant.id,
            'supplier': this.supplier.id,
        };

        let fields = [
            'deliveries { day hour orderMaxDay orderMaxHour }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantSupplierAssociation',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    fillForm(data){
        var self = this;
        this.association = data.restaurantSupplierAssociation;
        
        this.$btnBack = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-primary')
        .append(
            $('<i/>')
            .addClass('fa fa-arrow-left')
        )
        .append(' ')
        .append(window.translate('back'))
        .on('click',this.onClickBack)


        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-primary')
        .append(window.translate('continue'))
        .append(' ')
        .append(
            $('<i/>')
            .addClass('fa fa-arrow-right')
        );

        this.$form
        .html('')
        .append(this.buildInputs())
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-2 d-flex justify-content-start')
                .append(
                    this.$btnBack
                )
            )
            .append(
                $('<div/>')
                .addClass('col-6 p-2 d-flex justify-content-end')
                .append(
                    this.$btnSubmit
                )
            )
        );

        return this.$form;
    }

    buildInputs(){
        var self = this;    
        this.$box = $('<div/>');


        this.$deliveryDaysContainer = $('<div/>')
        .attr('data-lastindex',-1)
        .appendTo(this.$box);


        if(this.association){
            for(var index in this.association.deliveries){
                let delivery = this.association.deliveries[index];

                let orderDay = delivery.orderMaxDay;
                let orderHour = delivery.orderMaxHour;
                let deliveryDay = delivery.day;
                let deliveryHour = delivery.hour;

                let $item = this.buildDeliveryDayItem(index,orderDay,orderHour,deliveryDay,deliveryHour);

                this.$deliveryDaysContainer
                .attr('data-lastindex',index)
                .append($item)
            }
        }


        this.$btnAddDeliveryDay = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-secondary')
        .append(
            $('<i/>')
            .addClass('fal fa-plus-circle me-1')
        )
        .append(window.translate('app.restaurant.show.tabs.supplier.delivery.addDelivery.label'))
        .on("click",this.onClickBtnAddDeliveryDay)

        this.$box.append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-4')
            .append(this.$btnAddDeliveryDay)
        );

        return this.$box;
    }

    buildDeliveryDayItem(index,orderDay,orderHour,deliveryDay,deliveryHour){
        var self = this;
        let $item = $('<div/>')
        .attr('data-index',index)
        .addClass('restaurant-supplier-delivery-item')
        .addClass('card mb-2');

        let $btnDelete = $('<button/>')
        .attr('type',"button")
        .addClass('btn btn-text text-danger')
        .append(
            $('<i/>')
            .addClass('fas fa-trash')
        )
        .on("click",function(){
            self.removeDeliveryDayItem(index)
        });

        let allDays = this.getAllDays();
        let allHours = this.getAllHours();

        let inputNamePrefix = "deliveries["+index+"]";

        let $selectDeliveryDay = $('<select/>')
        .addClass('form-control')
        .attr("id","deliveryDay"+index)
        .attr('name',inputNamePrefix+"[day]")
        .on("change",function(){
            self.onChange();
        });

        let $selectDeliveryHour = $('<select/>')
        .addClass('form-control')
        .attr("id","deliveryHour"+index)
        .attr('name',inputNamePrefix+"[hour]")
        .on("change",function(){
            self.onChange();
        });

        let $selectOrderDay = $('<select/>')
        .addClass('form-control')
        .attr("id","orderDay"+index)
        .attr('name',inputNamePrefix+"[orderMaxDay]")
        .on("change",function(){
            self.onChange();
        });

        let $selectOrderHour = $('<select/>')
        .addClass('form-control')
        .attr("id","orderHour"+index)
        .attr('name',inputNamePrefix+"[orderMaxHour]")
        .on("change",function(){
            self.onChange();
        });

        for(var d in allDays){
            let day = allDays[d];

            let $optionOrder = $("<option/>")
            .val(day.value)
            .append(day.label);

            let $optionDelivery = $optionOrder.clone();

            if(orderDay && orderDay == day.value){
                $optionOrder.attr('selected','selected');
            }
            $selectOrderDay.append($optionOrder);

            if(deliveryDay && deliveryDay == day.value){
                $optionDelivery.attr('selected','selected');
            }
            $selectDeliveryDay.append($optionDelivery);
        }

        for(var h in allHours){
            let hour = allHours[h];

            let $optionOrder = $("<option/>")
            .val(hour.value)
            .append(hour.label);

            let $optionDelivery = $optionOrder.clone();

            if(orderHour && orderHour == hour.value){
                $optionOrder.attr('selected','selected');
            }
            $selectOrderHour.append($optionOrder);

            if(deliveryHour && deliveryHour == hour.value){
                $optionDelivery.attr('selected','selected');
            }
            $selectDeliveryHour.append($optionDelivery);
        }

        let $table = $('<table/>')
        .addClass('w-100')
        .append(
            $('<tbody/>')
            .append(
                $('<tr/>')
                .append(
                    $('<td/>')
                    .append(window.translate('app.restaurant.show.tabs.supplier.delivery.order.label'))
                )
                .append(
                    $('<td/>')
                    .addClass('p-2')
                    .append($selectOrderDay)
                )
                .append(
                    $('<td/>')
                    .append(window.translate('at'))
                )
                .append(
                    $('<td/>')
                    .addClass('p-2')
                    .append($selectOrderHour)
                )
            )
            .append(
                $('<tr/>')
                .append(
                    $('<td/>')
                    .append(window.translate('app.restaurant.show.tabs.supplier.delivery.delivery.label'))
                )
                .append(
                    $('<td/>')
                    .addClass('p-2')
                    .append($selectDeliveryDay)
                )
                .append(
                    $('<td/>')
                    .append(window.translate('at'))
                )
                .append(
                    $('<td/>')
                    .addClass('p-2')
                    .append($selectDeliveryHour)
                )
            )
        )


        let $row = $('<div/>')
        .addClass('row')
        .append(
            $('<div/>')
            .addClass('col-10')
            .append($table)
        )
        .append(
            $('<div/>')
            .addClass('col-2 d-flex justify-content-center align-middle')
            .append($btnDelete)
        );


        $item
        .append(
            $('<div/>')
            .addClass('card-body')
            .append($row)
        )

        return $item;
    }


    getAllDays(){
        let dayValues = [1,2,3,4,5,6,7];
        let days = [];
        for(var d in dayValues){
            let dayValue = dayValues[d];
            days.push({
                'value': dayValue,
                'label': window.translate('day'+dayValue)
            });
        }
        return days;
    }

    getAllHours(){
        let hours = [];
        let minutes = ["00","15","30","45"];
        for(var i=0;i<24;i++){
            let hour = i;
            if(hour < 10){
                hour = '0'+hour;
            }

            for(var m in minutes){
                let minute = minutes[m];
                let value = hour+':'+minute;
                let label = value;
                hours.push({
                    'value': value+':00',
                    'label': label
                });
            }
        }
        return hours;
    }

    onDOMReady(){
        super.onDOMReady();
    }

    getFields(){
        let fields = super.getFields();
        return fields;
    }
    
    getVariables(){
        let variables = {};

        variables.restaurant = {
            'value': this.restaurant.id,
            'type': 'Int!'
        };

        variables.supplier = {
            'value': this.supplier.id,
            'type': 'Int!'
        };

        return variables;
    }

    onClickBack(event){
        this.settings.onClickBack(this);
    }

    onClickBtnAddDeliveryDay(event){
        let index = this.$deliveryDaysContainer.data('lastindex');
        index++;

        let $item = this.buildDeliveryDayItem(index);
        this.$deliveryDaysContainer
        .data('lastindex',index)
        .attr('data-lastindex',index)
        .append($item);

        this.onChange();
    }

    removeDeliveryDayItem(index){
        let $item = $('.restaurant-supplier-delivery-item[data-index="'+index+'"',this.$deliveryDaysContainer);
        $item.remove();
        this.onChange();
    }

    onChange(){
        this.changed = true;
        this.settings.onChange();
    }

    onSuccess(){
        this.changed = false;
        super.onSuccess();
    }

}

module.exports = DeliveryForm;

